/**
 * Read the customer `feedback` setting authored in csv customerSettings.
 *
 *   feedback: {
 *     enabled: true,
 *     sensitiveInformation: true,
 *   }
 *
 * When `sensitiveInformation` is true, problem reports must not capture or upload a screenshot.
 */

const emptyFeedbackSettings = () => ({
  enabled: false,
  sensitiveInformation: false
});
export const normalizeFeedbackSettings = value => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return emptyFeedbackSettings();
  }
  return {
    enabled: value.enabled === true,
    sensitiveInformation: value.sensitiveInformation === true
  };
};
export const readFeedbackSettings = (settings = {}) => normalizeFeedbackSettings(settings.feedback);
export const allowsFeedbackScreenshots = feedbackSettings => {
  const normalized = normalizeFeedbackSettings(feedbackSettings);
  return normalized.enabled && !normalized.sensitiveInformation;
};